<template>
  <div>
    <v-form ref="refMain">
      <v-container fluid>
        <v-row fluid>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-autocomplete v-model="dOrgId" label="* Unidad de Negocio"
                            :items="dOrg" item-value="IdCentProd" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" class="pa-1">
            <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                            :items="dPriServicios" item-value="IdServicio" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFInicioMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFInicio"
                    label="Fecha Matricula Desde"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFInicio"
                  @input="dFInicioMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFFinMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFFin"
                    label="Fecha Matricula Hasta"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFFin"
                  @input="dFFinMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-select v-model="dLmsId" label="Lms"
                      :items="dLms"
                      filled prepend-inner-icon="school"></v-select>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" class="pa-1">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-card-title>
        <v-text-field
            v-model="dTable.search"
            prepend-icon="search"
            label="Filtrar por ..."
            single-line
            dense
            hide-details
            clearable
        ></v-text-field>
      </v-card-title>
      <v-data-table
          v-model="dTable.selected"
          :headers="dTable.headers"
          :items="dMatMatriculas"
          :loading="dTable.loading"
          :search="dTable.search"
          item-key="IdMatricula"
          show-select
          class="elevation-1">
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
        <template v-slot:[`item.matseccion`]="{ item }">
          <span>{{item.matseccion.matperiodo.Anio +"-"+item.matseccion.matperiodo.Periodo+" "+item.matseccion.matperiodo.Nivel+"° "+item.matseccion.Seccion}}</span>
        </template>
        <template v-slot:[`item.Enviado`]="{ item }">
          <span>{{item.Enviado | fEstado}}</span>
        </template>
      </v-data-table>
    </v-card>
    <v-divider></v-divider>
    <div class="pa-3 blue-grey darken-2">
      <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary"><v-icon left>autorenew</v-icon> Reiniciar Proceso</v-btn>
    </div>
    <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
      <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
  name: 'MatMatricula',
  data: () => ({
    dFInicio: moment().subtract(30,'d').format('YYYY-MM-DD'),
    dFInicioMenu: false,
    dFFin: moment().format('YYYY-MM-DD'),
    dFFinMenu: false,
    dIsUpdating: false,
    dIdServicio: '',
    dMatMatriculas: [],
    dSnackbar: false,
    dPriServicios: [],
    dOrgId: '',
    dOrg: [],
    dLmsId: '',
    dLms: [
      {value: 1, text: '1 - Teams' },
      {value: 2, text: '2 - Moodle' },
      {value: 3, text: '3 - Canvas - Instructure' },
      {value: 4, text: '4 - Canvas - Khipu' },
      {value: '', text: 'Otro' },
    ],
    dTable: {
      headers: [
        {value: 'IdMatricula', text: 'IdMatricula', align: ' d-none'},
        {value: 'Codigo', text: 'Codigo'},
        {value: 'Alumno', text: 'Alumno'},
        {value: 'Iniciales', text: 'Prog. Est.'},
        {value: 'Seccion', text: 'Sección'},
        {value: 'FechaMatricula', text: 'Fecha Matricula'},
        {value: 'Enviado', text: 'Estado'}
      ],
      loading: false,
      search: null,
      selected: [],
      Usuario: null
    }
  }),
  watch: {
    'dOrgId' (val) {
      this.fuLoad(val);
    }
  },
  mounted(){
    this.Usuario = JSON.parse(localStorage.getItem('ssUser'))
    this.fuLoadOrg(this.Usuario)
  },
  methods: {
    async fuLoad(Unidad){
      const response = await this.$apollo.query({
        query: gql`query priservicioByIdCentroProdByActivo($IdCentroProd: Int!){
                    priservicioByIdCentroProdByActivo (IdCentroProd: $IdCentroProd, Activo: 1){
                      IdServicio
                      Descripcion
                    }
                }`,
        variables: {
          IdCentroProd: Unidad
        }
      })
      this.dPriServicios = response.data.priservicioByIdCentroProdByActivo;
    },
    async fuLoadOrg(User){
      const response = await this.$apollo.query({
        query: gql`query centProdLmsUsuario($Usuario: String!){
                    centProdLmsUsuario(Usuario: $Usuario){
                      IdCentProd
                      Descripcion
                      Usuario
                    }
                }`,
        variables: {
          Usuario: User.Usuario
        }
      })
      this.dOrg = response.data.centProdLmsUsuario;
    },
    fuSearch(){
      if(!this.$refs.refMain.validate()){
        this.dSnackbar = true;
      } else {
        this.fuMatmatriculaByActivoByEnviadoByFechas();
      }
    },
    async fuMatmatriculaByActivoByEnviadoByFechas(){
      this.dTable.selected = [];
      this.dTable.loading = true;
      let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
      let vFFin =this.dFFin.substring(0,10).split("-").join("");
      try {
        const response = await this.$apollo.query({
          query: gql`query matmatriculaLmsCentProd($IdCentroProd: Int!, $Enviado: String!, $IdServicio: String!, $FInicio: String!, $FFin: String!, $Lms: String){
                        matmatriculaLmsCentProd(IdCentroProd:$IdCentroProd, IdServicio:$IdServicio, Enviado:$Enviado, FechaInicio:$FInicio, FechaFin:$FFin, Lms:$Lms){
                            IdMatricula
                            IdSeccion
                            IdAlumno
                            FechaMatricula
                            Enviado
                            Codigo
                            Alumno
                            Iniciales
                            Anio
                            Periodo
                            Seccion
                            Nivel
                            Lms
                        }
                    }`,
          variables: {
            Enviado: '0,2,3,4,5,90,91,92,93,94',
            FInicio: vFInicio,
            FFin: vFFin,
            IdServicio: this.dIdServicio,
            IdCentroProd: this.dOrgId,
            Lms: this.dLmsId,
          },
          fetchPolicy: 'no-cache'
        })

        this.dMatMatriculas = [];
        this.dMatMatriculas = response.data.matmatriculaLmsCentProd;
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dTable.loading = false
      }
    },
    fuSave(){
      if(this.dTable.selected.length===0){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        this.fuMatmatriculaEnviadoByIdMatriculaUpdate();
      }
    },
    async fuMatmatriculaEnviadoByIdMatriculaUpdate(){
      let vIdMatriculas = this.dTable.selected.map(x=>x.IdMatricula);
      vIdMatriculas = vIdMatriculas.reduce((acc, el)=> acc+','+el, '');
      vIdMatriculas = vIdMatriculas.substring(1);
      this.dIsUpdating = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation matmatriculaupdateLmsCentProd($IdCentroProd:Int!, $IdMatricula: String!){
                        matmatriculaupdateLmsCentProd(IdCentroProd: $IdCentroProd, IdMatricula: $IdMatricula){
                            success
                            message
                        }
                    }`,
          variables: {
            IdCentroProd : this.dOrgId,
            IdMatricula : vIdMatriculas
          }
        });
        if(response.data.matmatriculaupdateLmsCentProd.success==0){
          Swal.fire('¡ ERROR !', 'No se modifico la(s) matricula(s).', 'error');
        } else {
          // this.fuMatmatriculaEnviadoByIdMatriculaUpdate()
          Swal.fire('CORRECTO', 'Se modifico la(s) matricula(s).', 'success');
          this.dMatMatriculas = [];
          this.fuMatmatriculaByActivoByEnviadoByFechas()
        }
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dIsUpdating = false;
      }
    },
  },
  filters: {
    fEstado: function (value) {
      let vMessage=''
      switch (value) {
        case 0:
          vMessage=value+' - En espera de proceso';
          break;
        case 1:
          vMessage=value+' - Proceso completado';
          break;
        case 2:
          vMessage=value+' - En espera de paso 02';
          break;
        case 3:
          vMessage=value+' - En espera de paso 03';
          break;
        case 4:
          vMessage=value+' - En espera de paso 04';
          break;
        case 5:
          vMessage=value+' - En espera de paso 05';
          break;
        case 90:
          vMessage=value+' - Creación de Correo Google (FALLO)';
          break;
        case 91:
          vMessage=value+' - Creación de Usuario Microsoft';
          break;
        case 92:
          vMessage=value+' - Convierte Usuario Microsoft a Estudiante';
          break;
        case 93:
          vMessage=value+' - Asigna licencia al Estudiante';
          break;
        case 94:
          vMessage=value+' - Asigna Cursos al Estudiante';
          break;
        default:
          vMessage=value+' - Otro Error';
          break;
      }
      return vMessage;
    }
  }
}
</script>